import { api } from 'services/api';

export const dropboxService = api.injectEndpoints({
  endpoints: (builder) => ({
    search: builder.query<ResultModel<SearchResponse[]>, SearchRequest>({
      query: (body) => ({
        url: `/50206DA13DD76C/GetFilterOptions`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useSearchQuery } = dropboxService;
